module.exports = __webpack_public_path__ + "img/desktop-solid.ab3bd38d.svg";